import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js';
function EditEqp() {
    const {id} = useParams();
    const [subcats, setSubcats] = useState([]);
    const [dists, setDists] = useState([]);
    const [registerFormData, setRegisterFormData] = useState({
        supp: '',
        subcat: '',
        hsn: '',
        product: '',
        brand: '',
        model_no: '',
        serial_no: '',
        unit: '',
        pack: '',
        qty: '',
        totqty: '',
        mrp: '',
        pprice: '',
        disc: '',
        sgst: '',
        cgst: '',
        gstamount: '',
        netamount: '',
        uamount: '',
        residual_value: '',
        useful_life_years: 5,
        annual_depreciation: '',
        current_asset_value: '',
        depreciation_method: 'SLM',
        purchase_date: null,
        warranty_start: null,
        warranty_end: null,
        amc_type: '',
        amc_vendor: '',
        amc_start: null,
        amc_end: null,
    });
    // =========================
    // LOAD DATA
    // =========================
    useEffect(() => {
        axios.get(`${baseUrl}update-eqp-qty/${id}/`)
            .then(response => {
                const data = response.data;
                console.log('EDIT DATA =>', data);
                setRegisterFormData({
                    supp: data.supp ? data.supp.id : '',
                    subcat: data.subcat ? data.subcat.id : '',
                    hsn: data.hsn || '',
                    product: data.product || '',
                    brand: data.brand || '',
                    model_no: data.model_no || '',
                    serial_no: data.serial_no || '',
                    unit: data.unit || '',
                    pack: data.pack || '',
                    qty: data.qty || '',
                    totqty: data.totqty || '',
                    mrp: data.mrp || '',
                    pprice: data.pprice || '',
                    disc: data.disc || '',
                    sgst: data.sgst || '',
                    cgst: data.cgst || '',
                    gstamount: data.gstamount || '',
                    netamount: data.netamount || '',
                    uamount: data.uamount || '',
                    residual_value:
                        data.residual_value || '',
                    useful_life_years:
                        data.useful_life_years || 5,
                    annual_depreciation:
                        data.annual_depreciation || '',
                    current_asset_value:
                        data.current_asset_value || '',
                    depreciation_method:
                        data.depreciation_method || 'SLM',
                    purchase_date:
                        data.purchase_date
                            ? new Date(data.purchase_date)
                            : null,
                    warranty_start:
                        data.warranty_start
                            ? new Date(data.warranty_start)
                            : null,
                    warranty_end:
                        data.warranty_end
                            ? new Date(data.warranty_end)
                            : null,
                    amc_type:
                        data.amc_type || '',
                    amc_vendor:
                        data.amc_vendor || '',
                    amc_start:
                        data.amc_start
                            ? new Date(data.amc_start)
                            : null,
                    amc_end:
                        data.amc_end
                            ? new Date(data.amc_end)
                            : null,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }, [id]);
    // =========================
    // LOAD DROPDOWNS
    // =========================
    useEffect(() => {
        axios.get(`${baseUrl}add-supplier/`)
            .then(response => setDists(response.data))
            .catch(error => console.log(error));
        axios.get(`${baseUrl}eqp-subcat/`)
            .then(response => setSubcats(response.data))
            .catch(error => console.log(error));
    }, []);
    // =========================
    // HANDLE CHANGE
    // =========================
    const handleChange = (e) => {
        const {name, value} = e.target;
        setRegisterFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };
    // =========================
    // HANDLE DATE
    // =========================
    const handleDateChange = (name, date) => {
        setRegisterFormData(prev => ({
            ...prev,
            [name]: date
        }));
    };
    // =========================
    // CALCULATIONS
    // =========================
    useEffect(() => {
        calculateAmounts();
    }, [
        registerFormData.qty,
        registerFormData.pack,
        registerFormData.pprice,
        registerFormData.disc,
        registerFormData.sgst,
        registerFormData.cgst,
        registerFormData.useful_life_years,
        registerFormData.residual_value
    ]);
    const calculateAmounts = () => {
        const qty =
            parseFloat(registerFormData.qty || 0);
        const pack =
            parseFloat(registerFormData.pack || 0);
        const pprice =
            parseFloat(registerFormData.pprice || 0);
        const disc =
            parseFloat(registerFormData.disc || 0);
        const sgst =
            parseFloat(registerFormData.sgst || 0);
        const cgst =
            parseFloat(registerFormData.cgst || 0);
        const residual =
            parseFloat(registerFormData.residual_value || 0);
        const years =
            parseFloat(registerFormData.useful_life_years || 1);
        const totqty = qty * pack;
        const net = qty * pprice;
        const discAmt = (net * disc) / 100;
        const taxable = net - discAmt;
        const gstPercent = sgst + cgst;
        const gstAmt = (taxable * gstPercent) / 100;
        const finalAmount = taxable + gstAmt;
        const annualDep =
            (pprice - residual) / years;
        const currentValue =
            pprice - annualDep;
        setRegisterFormData(prev => ({
            ...prev,
            totqty: totqty,
            gstamount: gstAmt.toFixed(2),
            netamount: finalAmount.toFixed(2),
            annual_depreciation:
                annualDep.toFixed(2),
            current_asset_value:
                currentValue.toFixed(2),
            uamount:
                pack > 0
                    ? (pprice / pack).toFixed(2)
                    : 0
        }));
    };
    // =========================
    // UPDATE
    // =========================
    const submitHandler = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            Object.keys(registerFormData).forEach(key => {
                let value = registerFormData[key];
                if (value instanceof Date) {
                    value =
                        value.toISOString().split('T')[0];
                }
                if (
                    value === null ||
                    value === undefined
                ) {
                    value = '';
                }
                formData.append(key, value);
                console.log(key, value);
            });
            formData.append('status', 1);
            formData.append('addedby', userName);
            formData.append('ip_add', ipAddress);
            formData.append('location', userLocation);
            const response = await axios.put(
                `${baseUrl}update-eqp-qty/${id}/`,
                formData,
                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data'
                    }
                }
            );
            console.log(response.data);
            Swal.fire({
                title: 'Equipment Updated Successfully',
                icon: 'success',
                timer: 2000,
                showConfirmButton: false,
            });
            setTimeout(() => {
                window.location.href =
                    '/equip-list/';
            }, 2000);
        } catch (error) {
            console.log(error);
            console.log(error.response);
            Swal.fire({
                title: 'Error',
                text: JSON.stringify(
                    error.response?.data
                ),
                icon: 'error',
            });
        }
    };
    return (
        <section className="container-fluid mt-4 mb-5">

            <div className="card shadow">

                <div
                    className="card-header text-white"
                    style={{
                        backgroundColor: '#1bc5ce'
                    }}
                >
                    <h4 className="mb-0">
                        Edit Equipment Asset
                    </h4>
                </div>

                <div className="card-body">

                    <form onSubmit={submitHandler}>

                        <div className="row">

                            <div className="col-md-3 mb-3">

                                <label>
                                    Supplier
                                </label>

                                <select
                                    className="form-control"
                                    name="supp"
                                    value={registerFormData.supp}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        Select Supplier
                                    </option>

                                    {dists.map((dist, index) => (
                                        <option
                                            key={index}
                                            value={dist.id}
                                        >
                                            {dist.name}
                                        </option>
                                    ))}

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    HSN
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="hsn"
                                    value={registerFormData.hsn}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-6 mb-3">

                                <label>
                                    Equipment Name
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="product"
                                    value={registerFormData.product}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Category
                                </label>

                                <select
                                    className="form-control"
                                    name="subcat"
                                    value={registerFormData.subcat}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        Select Category
                                    </option>

                                    {subcats.map((subcat, index) => (
                                        <option
                                            key={index}
                                            value={subcat.id}
                                        >
                                            {subcat.subcat}
                                        </option>
                                    ))}

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Brand
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="brand"
                                    value={registerFormData.brand}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Model No
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="model_no"
                                    value={registerFormData.model_no}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Serial No
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="serial_no"
                                    value={registerFormData.serial_no}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-2 mb-3">

                                <label>
                                    Pack
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="pack"
                                    value={registerFormData.pack}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-2 mb-3">

                                <label>
                                    Qty
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="qty"
                                    value={registerFormData.qty}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-2 mb-3">

                                <label>
                                    Tot Qty
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    value={registerFormData.totqty}
                                    readOnly
                                />

                            </div>

                            <div className="col-md-2 mb-3">

                                <label>
                                    Unit
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="unit"
                                    value={registerFormData.unit}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-2 mb-3">

                                <label>
                                    Purchase Price
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="pprice"
                                    value={registerFormData.pprice}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-2 mb-3">

                                <label>
                                    MRP
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="mrp"
                                    value={registerFormData.mrp}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Purchase Date
                                </label>

                                <DatePicker
                                    selected={
                                        registerFormData.purchase_date
                                    }
                                    onChange={(date) =>
                                        handleDateChange(
                                            'purchase_date',
                                            date
                                        )
                                    }
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Warranty Start
                                </label>

                                <DatePicker
                                    selected={
                                        registerFormData.warranty_start
                                    }
                                    onChange={(date) =>
                                        handleDateChange(
                                            'warranty_start',
                                            date
                                        )
                                    }
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Warranty End
                                </label>

                                <DatePicker
                                    selected={
                                        registerFormData.warranty_end
                                    }
                                    onChange={(date) =>
                                        handleDateChange(
                                            'warranty_end',
                                            date
                                        )
                                    }
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    AMC Type
                                </label>

                                <select
                                    className="form-control"
                                    name="amc_type"
                                    value={registerFormData.amc_type}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        Select AMC
                                    </option>

                                    <option value="AMC">
                                        AMC
                                    </option>

                                    <option value="CMC">
                                        CMC
                                    </option>

                                    <option value="NONE">
                                        None
                                    </option>

                                </select>

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Residual Value
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="residual_value"
                                    value={registerFormData.residual_value}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Useful Life Years
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="useful_life_years"
                                    value={registerFormData.useful_life_years}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Annual Depreciation
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={registerFormData.annual_depreciation}
                                    readOnly
                                />

                            </div>

                            <div className="col-md-3 mb-3">

                                <label>
                                    Current Asset Value
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={registerFormData.current_asset_value}
                                    readOnly
                                />

                            </div>

                        </div>

                        <div className="text-center mt-4">

                            <button
                                type="submit"
                                className="btn btn-success px-5"
                            >
                                Update
                            </button>

                        </div>

                    </form>

                </div>

            </div>

        </section>
    );
}
export default EditEqp;